import { useState, type ComponentProps } from "react";
import { Button } from "@heroui/react";
import { useTranslation } from "react-i18next";
import type { Order } from "@/api.types.v2";
import { PayOrderDialog } from "./pay-order-dialog";

export function PayOrderButton({
  order,
  color = "primary",
}: {
  order: Order;
  color?: ComponentProps<typeof Button>["color"];
}) {
  const { t } = useTranslation("app");
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size="sm" color={color} onPress={() => setOpen(true)}>
        {t("orders.pay")}
      </Button>
      {open && (
        <PayOrderDialog
          open
          onOpenChange={setOpen}
          orderId={order.id}
          totalCents={order.balanceCents ?? order.totalCents ?? 0}
          orderNumber={order.shipments?.[0]?.shipmentNumber?.toString()}
        />
      )}
    </>
  );
}
